import { NotificationModel } from './../../../../model/notification.model';

import { INotificationDropdownState } from './state';
import { createReducer, on, Action } from '@ngrx/store';
import {
  onNgrxForms, onNgrxFormsAction, SetValueAction
} from 'ngrx-forms';
import { ResponseAction } from './actions';

export const state: INotificationDropdownState = {
  list: [],
};

const reducer = createReducer(state,
  onNgrxForms(),
  onNgrxFormsAction(SetValueAction, (state, action) => {
    return state;
  }),
  on(ResponseAction, (state, { payload }) => {
    return {
      ...state,
      list: payload,
    };
  })
);

export function notificationDropdownReducer(state: any | undefined, action: Action) {
  return reducer(state, action);
}
